import React from 'react';
import PropTypes from 'prop-types';
import { If, Then, Else } from 'react-if';
import { Container, Row, Navbar } from 'reactstrap';
import classNames from 'classnames';
import './styles.css';
import { IS_SIDEKICK_APP, IS_VALIDATE_APP } from '../../../constants/projects';
import { ReactComponent as SidekickLogo } from '../Main/sidekick-studios-logo.svg';

const UnauthorizedLayout = ({ children }) => {
    return (
        <div
            className={classNames({
                'unauthorized--sidekick': IS_SIDEKICK_APP,
                unauthorized: IS_VALIDATE_APP,
            })}
        >
            <If condition={IS_VALIDATE_APP}>
                <Then>
                    <div className="unauthorized-header">
                        <Container>
                            <Row>
                                <Navbar>
                                    <a
                                        href="https://validate.biz/"
                                        className="logo-black"
                                        rel="home"
                                    >
                                        <img
                                            src="https://validate.biz/wp-content/uploads/2020/04/Asset-4@2x.png"
                                            width="125"
                                            height="30"
                                            alt="Validate"
                                        />
                                    </a>
                                </Navbar>
                            </Row>
                        </Container>
                    </div>
                </Then>
                <Else>
                    <div className="sidekick-logo">
                        <SidekickLogo />
                    </div>
                </Else>
            </If>
            <div
                className={classNames({
                    'sidekick-container': IS_SIDEKICK_APP,
                })}
            >
                {children}
            </div>
        </div>
    );
};

UnauthorizedLayout.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default React.memo(UnauthorizedLayout);
